/**
 * @example
 * // returns 'margin: 1rem;'
 * return(<EmotionComponent css={helperMargin('10rem')} />);
 * @example
 * // returns 'margin-left: 1rem;'
 * return(<div css={helperMargin({ left: 10 })} />);
 * @example
 * // returns 'margin-left: 1rem; margin-top: 1rem'
 * return(<span css={helperMargin({ left: 10, top: 10 })} />);
 */

import { css } from '@emotion/react';
import { Media, UnitValue } from '../types';
import { setDeclaration } from '../utils';

interface MarginProps {
  left?: UnitValue | Media<UnitValue>;
  right?: UnitValue | Media<UnitValue>;
  top?: UnitValue | Media<UnitValue>;
  bottom?: UnitValue | Media<UnitValue>;
}

export const helperMargin = (props: MarginProps | string) => {
  if (typeof props === 'object') {
    const { left, right, top, bottom } = props;

    return css`
      ${setDeclaration('marginLeft', left, 'rem')};
      ${setDeclaration('marginRight', right, 'rem')};
      ${setDeclaration('marginTop', top, 'rem')};
      ${setDeclaration('marginBottom', bottom, 'rem')};
    `;
  }

  return css`
    margin: ${props};
  `;
};
